import { JobApi } from 'api/JobApi';
import { backendApiClient } from 'container/backendApiClient';

export const jobApi = new JobApi(backendApiClient);
